export const ScubaTagValue = 'Scuba';
export const WebPlatform = 'Web';
export const ServiceName = 'Portal Web';
export const Exception = 'Exception';
